<template>
    <div class="tcpa-disclosure--text">
        <span>
            By clicking {{ submitText }}, I agree to {{ brand }}'s
            <span
                v-ls-track.click="{
                    target: trackClickTarget,
                }"
                class="tcpa-disclosure---link"
                test-id="tos"
                @click.prevent.stop="openModal('termsOfService')"
            >
                terms of service
            </span>
            and I agree that {{ brand }} or one of its
            <a :href="trustedPartnersLink" target="_blank" class="tcpa-disclosure---link">
                trusted partners
            </a>
            (including, but not limited to, Craft Jack, Modernize, Networx, or Angi) may contact me
            by phone, SMS, or email, including for marketing purposes and through automated phone
            technology. {{ brand }} may earn either a commission or a flat amount from its partners
            for giving professionals the opportunity to bid on your project. By using this service,
            I also agree to be bound by
            <a :href="angiTosLink" target="_blank" class="tcpa-disclosure---link">
                Angi's Terms of Service
            </a>
            and
            <a :href="angiPolicyLink" target="_blank" class="tcpa-disclosure---link">
                Privacy Policy
            </a>
            and
            <a :href="craftjackTosLink" target="_blank" class="tcpa-disclosure---link">
                Craft Jack's Terms of Service
            </a>
            and
            <a :href="craftjackPolicyLink" target="_blank" class="tcpa-disclosure---link">
                Privacy Policy
            </a>
            to the extent I use their services.
        </span>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import brandMixin from '@/mixins/brand.mixin';
import { MODAL__OPEN_MODAL } from '@/store/types';

export default {
    mixins: [brandMixin],
    props: {
        submitText: {
            type: String,
            required: true,
        },
        trackClickTarget: {
            type: String,
            required: true,
        },
        linkClassName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            trustedPartnersLink: 'https://www.lawnstarter.com/blog/trusted-partners',
            angiTosLink: 'https://www.angi.com/terms#contract-skmav5s0l',
            angiPolicyLink: 'https://www.angi.com/terms#contract-h1zrnbhtx',
            craftjackTosLink: 'https://legal.craftjack.com/#craftjack-terms-and-conditions',
            craftjackPolicyLink: 'https://legal.craftjack.com/#craftjack-privacy-policy',
        };
    },
    methods: {
        ...mapActions({
            openModal: MODAL__OPEN_MODAL,
        }),
    },
};
</script>

<style lang="scss">
.tcpa-disclosure--text {
    font-size: 0.75rem;
    line-height: 1rem;
}

.tcpa-disclosure---link {
    color: $theme-color-blue;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
}
</style>
